import BannerEdition from '@/modules/assetImage/components/bannerEdition';
import BannerViwer from '@/modules/assetImage/components/bannerViwer';
import { ASSET_IMAGE_TYPE } from '@/modules/assetImage/entities/enums';
import { AssetImage } from '@/modules/assetImage/entities/interfaces';
import AssetImagesService from '@/modules/assetImage/services/assetImagesService';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import { USER_PERMISSIONS } from '@/modules/user/entities/user.const';
import { useRequestReadOne } from '@/shared/hooks/useRequestData/useRequestReadOne';
import { errorReports } from '@/shared/telemetry/telemetry';
import { isAxiosError } from 'axios';
import React, { useCallback } from 'react';

const assetImagesService = new AssetImagesService();

const BANNER_MANAGEMENT_PERMISSIONS = [
  USER_PERMISSIONS.ASSET_IMAGE_CREATE,
  USER_PERMISSIONS.ASSET_IMAGE_UPDATE,
  USER_PERMISSIONS.ASSET_IMAGE_DELETE,
];

const Banner: React.FC = () => {
  const { checkUserHasSomePermission } = useCurrentUser();

  const fetchLatestBanner = useCallback(async (): Promise<AssetImage | undefined> => {
    const { data } = await assetImagesService.listAssetImages({
      pageSize: 1,
      type: ASSET_IMAGE_TYPE.BANNER,
      sort: '-initialDate',
    });

    const latestBanner = data?.[0];

    if (!latestBanner) {
      return undefined;
    }

    try {
      return await assetImagesService.showAssetImage(latestBanner.id);
    } catch (error) {
      // Banner removido entre a listagem e o detalhe (404): não exibir é aceitável.
      if (isAxiosError(error) && error.response?.status === 404) {
        return undefined;
      }

      // Demais falhas (403 de IAM, 500, timeout) são reportadas e propagadas
      // para o tratamento padrão do hook (sem expor a URL assinada).
      errorReports.exception(error);
      throw error;
    }
  }, []);

  const {
    data: assetImage,
    loading,
    loadData,
  } = useRequestReadOne<AssetImage | undefined>({
    source: fetchLatestBanner,
  });

  const canManageBanner = checkUserHasSomePermission(BANNER_MANAGEMENT_PERMISSIONS);

  return canManageBanner ? (
    <BannerEdition assetImage={assetImage} loading={loading} refreshData={loadData} />
  ) : (
    <BannerViwer assetImage={assetImage} />
  );
};

export default Banner;
